import { useState, useEffect } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IonButton, IonList, IonItem, IonSpinner } from '@ionic/react';

import { loggedInSelector } from 'selectors/userSelector';
import { appIsOnline } from 'selectors/AppSelector';

import AuthenticationActions from 'actions/AuthenticationActions';
import UnauthenticatedLayout from 'components/layouts/Unauthenticated';
import MagnumInput from 'components/helpers/MagnumInput';
import { preventDefault, getValue } from 'helpers/events';

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const online = useSelector(appIsOnline);
  const loggedIn = useSelector(loggedInSelector);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [{email, password}, setState] = useState({
    email: '',
    password: '',
  });

  useEffect(()   => {
    if (loggedIn) {
      if (location.state?.nextPathname) {
        history.replace(location.state.nextPathname);
      } else {
        history.push('/projects');
      }
    }
  }, [loggedIn]);

  const login = async () => {
    setLoading(true);
    setError("");
    try {
      await dispatch(AuthenticationActions.login(email, password));
    } catch (e) {
      if (e.response?.statusCode == 401) {
        setError("The email or password you entered is incorrect");
      } else {
        setError(_.get(e, 'response.body.error', e.message) ?? "Something went wrong");
      }
    }
    setLoading(false);
  };

  const setField = (field) => getValue((value) => {
    setState((state) => ({...state, [field]: value}));
  });

  return (
    <UnauthenticatedLayout>
      <h2 className="ion-padding">Welcome</h2>

      <form onSubmit={preventDefault(login)}>
        <IonList lines="full">
          {online ? <>
            {error && <IonItem color="warning">{error}</IonItem>}
            <IonItem>
              <MagnumInput label="Email"
                type="email"
                value={email}
                onIonChange={setField('email')}
                placeholder="yourname@example.com"
                autoComplete="username"
                required/>
            </IonItem>
            <IonItem>
              <MagnumInput label="Password"
                type="password"
                value={password}
                onIonChange={setField('password')}
                placeholder="****"
                autoComplete="current-password"
                required/>
            </IonItem>
            <div className="ion-padding">
              <IonButton expand="block" type="submit" color="primary" disabled={loading}>
                {loading && <IonSpinner name="lines-sharp-small"/>}
                Login
              </IonButton>
              <br/>
              <IonButton expand="block" type="button" color="dark" routerLink="/passwordmanager">
                Reset Password
              </IonButton>
            </div>
          </> : <>
            <IonItem color="warning">You must be online to log in</IonItem>
            <IonButton expand="full" type="button" onClick={login}>
              Retry
            </IonButton>
          </>}
        </IonList>
      </form>
    </UnauthenticatedLayout>
  );
}

export default withRouter(Login);
